<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Received"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>

              <table class="table table-sm">
                <thead>
                  <tr class="bg-light">
                    <th>From</th>
                    <th>To</th>
                    <th>Expected</th>
                    <th>Received</th>
                  </tr>
                </thead>
                <tbody>
                  <tr >
                    <td v-if="movement.from_branch">{{ movement.from_branch.code }}</td>
                    <td v-if="movement.to_branch">{{ movement.to_branch.code }}</td>
                    <td>{{ movement.debit }}</td>
                    <td>
                      <input class="form-control" v-model="movement.credit" type="number" :max="movement.debit" />
                    </td>
                  </tr>
                </tbody>
              </table>

          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import palletRepo from "@/api/repos/palletRepo";
import formBase from "@/components/common/FormBase";


export default {

  components: {
    formBase,
  },

  props:["id"],

  mounted() {
    this.getData();
  },

  data() {
    return {
      movement: {
      },

      loading: false,
      errors: null,
      submitStatus: null,
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await palletRepo.movement(this.id);
        this.movement = data.movement;

        } catch (error) {
        console.log(error);
      }
    },

    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      let invalid = false;

      if(this.movement.credit == null || this.movement.credit == ""){
          invalid = true;
      }

       if(this.movement.credit > this.movement.debit){
          invalid = true;
      }

      if (invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await palletRepo.movementReceived(this.movement);
          this.$emit("movementReceived");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

